import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VgApiService } from '@videogular/ngx-videogular/core';
@Component({
  selector: 'gen-mp4-viewer',
  templateUrl: './mp4-viewer.component.html',
  styleUrls: ['./mp4-viewer.component.scss']
})
export class Mp4ViewerComponent {
  @Input() showOverlayPlay: boolean = true;
  @Input() showBuffering: boolean = true;
  @Input() showPlayPause: boolean = true;
  @Input() showPlaybackButton: boolean = true;
  @Input() showScrubBar: boolean = true;
  @Input() showTrackSelector: boolean = true;
  @Input() showMute: boolean = true;
  @Input() showVolume: boolean = true;
  @Input() showFullScreen: boolean = true;
  @Input() showForwardSeek: boolean = true;
  @Input() showBackwardSeek: boolean = true;
  @Output() outputChannel: EventEmitter<any> = new EventEmitter();
  @Input() blobUrl: any;

  api: VgApiService;
  seek(type: boolean) {
    if (type) {
      this.api.seekTime(this.api.currentTime - 10);
    } else {
      this.api.seekTime(this.api.currentTime + 10);
    }
  }

  onPlayerReady(api: VgApiService) {
    this.api = api;
    this.api.getDefaultMedia().subscriptions.ended.subscribe(data => this.outputChannel.emit({ event: data}));
    this.api.getDefaultMedia().subscriptions.pause.subscribe(data => this.outputChannel.emit({ event: data}));
    this.api.getDefaultMedia().subscriptions.error.subscribe(data => this.outputChannel.emit({ event: data}));
    this.api.getDefaultMedia().subscriptions.abort.subscribe(data => this.outputChannel.emit({ event: data}));
    this.api.getDefaultMedia().subscriptions.canPlayThrough.subscribe(data => this.outputChannel.emit({ event: data}));
    this.api.getDefaultMedia().subscriptions.playing.subscribe(data => this.outputChannel.emit({ event: data}));

  }
}
